<template>
  <v-app>
    <v-content>
      <MainPage />
    </v-content>
    <v-footer absolute color="white" class="font-weight-light">
      <v-col class="footer-caption text-right" cols="12">
        ... yes the site is fully loaded. It's called minimalism
        <v-icon class="mdi-rotate-315" color="black"> mdi-sunglasses</v-icon>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import MainPage from "./components/MainPage";

export default {
  name: "App",

  components: {
    MainPage
  },

  data: () => ({})
};
</script>
<style lang="scss">
.footer-caption {
  font-family: "Source Code Pro", monospace;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 0.8rem;
}
</style>
